// Pure order + undo state for a reorderable list — knows nothing about the DOM.
// The controller owns rendering; this owns the id order and the undo history.
export class ArrangementOrder {
  constructor(ids = []) {
    this.ids = [...ids]
    this.history = []
  }

  get length() {
    return this.ids.length
  }

  get dirty() {
    return this.history.length > 0
  }

  indexOf(id) {
    return this.ids.indexOf(id)
  }

  positionOf(id) {
    return this.indexOf(id) + 1
  }

  // Seed the order without recording history (initial load).
  reset(ids) {
    this.ids = [...ids]
    this.history = []
  }

  // Replace the whole order, recording the previous one for undo (e.g. "start from").
  replaceAll(ids) {
    this.history.push({ ids: [...this.ids] })
    this.ids = [...ids]
  }

  moveBy(id, delta) {
    return this.moveTo(id, this.positionOf(id) + delta)
  }

  toTop(id) {
    return this.moveTo(id, 1)
  }

  toBottom(id) {
    return this.moveTo(id, this.length)
  }

  // Move `id` to a 1-based position (clamped). Returns whether the order changed.
  moveTo(id, position) {
    const from = this.indexOf(id)
    const to = Math.min(Math.max(position, 1), this.length) - 1
    if (from < 0 || from === to) return false

    this.history.push({ id, from })
    this.reposition(id, to)
    return true
  }

  undo() {
    const move = this.history.pop()
    if (!move) return false

    if (move.ids) {
      this.ids = move.ids
    } else {
      this.reposition(move.id, move.from)
    }
    return true
  }

  clearHistory() {
    this.history = []
  }

  reposition(id, to) {
    this.ids.splice(this.indexOf(id), 1)
    this.ids.splice(to, 0, id)
  }
}
